import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddMealNew from '../components/TrackerAddMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeTrackerMeal } from '../helpers/normalizers';
import { TrackerMealProps } from '../types';

const TrackerAddUserMealContainer: React.FC<TrackerMealProps> = (props) => {
  const normalizedProps = normalizeTrackerMeal(props);
  return (
    <TrackerAddMealNew
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      mode="backward-navigation"
    />
  );
};

export default withLoading(TrackerAddUserMealContainer, UniversalPlaceholder);
